import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import serverEndPoint from '../../dxdm';

function Contactus() {
    const [Address,] = useState("asif.naeem@nu.edu.pk")
    const [EmailAddressFrom, setEmailAddressFrom] = useState("")
    const [Name, setName] = useState("")
    const [Body, setBody] = useState("")
    return (
        <div>
            <div className="row" style={{
                textAlign: 'start',
                backgroundSize: 'cover',
                backgroundAttachment: 'fixed',
                backgroundImage: `
            url(${serverEndPoint}/images/contactUsImage.jpg)
            `}}>
                <div className="col-sm-12" style={{ padding: "5%", minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <h1 style={{ color: "rgb(40,109,181)", fontWeight: 'bolder' }}>Get in touch</h1>
                </div>
            </div>
            <br />
            <div style={{ textAlign: 'center', }}>
                <h2>Lets start a conversation</h2>
                <br />
                <div className='row'>
                    <div className='col-md-6'>

                    </div>
                    <div className='col-md-6'>
                        <h2 style={{ color: 'gray', marginBottom: '2vh' }}>Contact Details</h2>
                        <input
                            value={EmailAddressFrom}
                            onChange={(e) => setEmailAddressFrom(e.target.value)}
                            style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }} className='form-control' placeholder='Your Email' />
                        <input
                            value={Name}
                            onChange={(e) => setName(e.target.value)}
                            style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }} className='form-control' placeholder='Your Name' />
                        <textarea
                            value={Body}
                            onChange={(e) => setBody(e.target.value)}
                            rows={4} className='form-control' placeholder='Your Message' />
                        <div style={{marginTop:'1vh'}}>
                            <a style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }} className='btn btn-primary' href={`mailto:${Address}?subject=${'Inquiry Email From ' + Name
                                }
                        &Body=${Body}`}>Send Message</a>{" | "}
                            <Link to={'/'} style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }} className='btn btn-success'>Go to Home</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contactus
